(() => {
  const selector = '.p158-photography .product-card__image--second img, .p2-card .product-card__image--second img';
  const ready = async image => {
    if (!(image instanceof HTMLImageElement) || !image.matches(selector) || !image.complete || !image.naturalWidth) return;
    try { await image.decode(); } catch { return; }
    image.closest('.product-card__image-wrapper')?.classList.add('p17-second-ready');
  };
  document.addEventListener('load', event => ready(event.target), true);
  document.querySelectorAll(selector).forEach(ready);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll(selector).forEach(ready));
})();

// A package is one product, irrespective of its colour/stone variants.
// Keep one card per results grid, including cached and asynchronously appended results.
(() => {
  const grids = '#ProductsList, #predictive-search-results-products-list';
  const observed = new WeakSet();
  const deduplicate = grid => {
    const seen = new Set();
    grid.querySelectorAll('[data-bundle-card]').forEach(card => {
      const handle = card.dataset.bundleCard;
      if (!handle) return;
      if (!seen.has(handle)) { seen.add(handle); return; }
      const wrapper = card.closest('.f-column');
      if (wrapper && wrapper.parentElement === grid) wrapper.remove();
      else card.remove();
    });
  };
  const connect = () => document.querySelectorAll(grids).forEach(grid => {
    deduplicate(grid);
    if (observed.has(grid)) return;
    observed.add(grid);
    new MutationObserver(() => deduplicate(grid)).observe(grid, {childList:true, subtree:true});
  });
  connect();
  new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node =>
      node.nodeType === 1 && (node.matches(grids) || node.querySelector(grids))
    ))) connect();
  }).observe(document.body, {childList:true, subtree:true});
  window.addEventListener('pageshow', connect);
  document.addEventListener('shopify:section:load', connect);
})();

